import Modal from "react-bootstrap/Modal";
import React from "react";
import { Row, Col, Button } from "react-bootstrap";

const WelcomeModal = ({ name, videoUrl, showModal, onClose }) => {
  return (
    <>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-custom-width"
        backdrop="static"
        show={showModal}
      >
        <Modal.Body className="pt-32 pb-32">
          <Row className="mb-4">
            <h2 className="mob-style-heading text-center mb-0">
              Welcome to Gitcha, {name}!
            </h2>
            <div className="fb-login-tagline-desktop">
              You’ll want to watch this quick 5 minute walkthrough to help get
              you started with the basics of Gitcha.
            </div>
          </Row>
          <Row>
            <Col xl={12} className="mb-4">
              <div style={{ width: "100%", height: "100%" }}>
                <video
                  width={"100%"}
                  height={"100%"}
                  controls
                  src={videoUrl}
                ></video>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xl={12} className="mb-4">
              <div className="modal-btn-wrap">
                <a
                  href="https://www.gitcha.com/help"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-100"
                >
                  <Button variant="outline-primary" className="btn w-100">
                    View All Tutorials
                  </Button>
                </a>
              </div>
            </Col>
            <Col xl={12}>
              <div className="modal-btn-wrap">
                <Button
                  variant="primary"
                  className={true ? " btn w-100" : "btn w-100 disabled"}
                  onClick={onClose}
                >
                  Continue
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default WelcomeModal;
